import { Component, EventEmitter, Input, Output } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-donate-button',
  templateUrl: './donate-button.component.html',
  styleUrls: ['./donate-button.component.scss'],
})
export class DonateButtonComponent {
  @Input({ required: true }) public isMenuItem: boolean;
  @Output() clickAction: EventEmitter<void> = new EventEmitter<void>();

  public paypalDonateUrl = environment.paypalDonateUrl;

  public openDonateUrl(): void {
    window.open(this.paypalDonateUrl, '_blank');
    this.clickAction.emit();
  }
}
